import { render, staticRenderFns } from "./gzzx.vue?vue&type=template&id=f022b362&scoped=true"
import script from "./gzzx.vue?vue&type=script&lang=js"
export * from "./gzzx.vue?vue&type=script&lang=js"
import style0 from "./gzzx.vue?vue&type=style&index=0&id=f022b362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f022b362",
  null
  
)

export default component.exports